/* ----------------------------------------
 * Vue-router設定
 *-----------------------------------------*/
import Vue from 'vue';
import VueRouter from 'vue-router';
import { SysConst as SC } from '@/trials/plugins/const';

import trialsMenu from '@/trials/views/trials/TrialsMenu.vue';

import trainKCMenu from '@/trials/views/trials/train/kc/KC.vue';
import trainKCList from '@/trials/views/trials/train/kc/KCList.vue';
import trainKCTraining from '@/trials/views/trials/train/kc/KCTraining.vue';

import trainDataMenu from '@/trials/views/trials/train/data/TrainData.vue';
import trainUpload from '@/trials/views/trials/train/data/TrainDataUpload.vue';
import trainStatistics from '@/trials/views/trials/train/data/TrainDataStatistics.vue';
import trainGettingKcList from '@/trials/views/trials/train/data/TrainDataGettingKcList.vue';

import trainResultMenu from '@/trials/views/trials/train/result/TrainResultMenu.vue';
import trainResultAll from '@/trials/views/trials/train/result/TrainResultAll.vue';
import trainResultKC from '@/trials/views/trials/train/result/TrainResultKC.vue';
import trainResultParams from '@/trials/views/trials/train/result/TrainResultParams.vue';
import trainResultData from '@/trials/views/trials/train/result/TrainResultData.vue';

import predictDataMenu from '@/trials/views/trials/predict/data/PredictData.vue';
import predictUpload from '@/trials/views/trials/predict/data/PredictDataUpload.vue';
import predictStatistics from '@/trials/views/trials/predict/data/PredictDataStatistics.vue';
import predicting from '@/trials/views/trials/predict/data/PredictDataPredicting.vue';

import predictResultMenu from '@/trials/views/trials/predict/result/PredictResultMenu.vue';
import predictResultData from '@/trials/views/trials/predict/result/PredictResultData.vue';

Vue.use(VueRouter);

var router = new VueRouter({
    mode: 'history',
    base: SC.Path.APP_BASE,
    routes: [
        {
            path: SC.Path.TRIALS_MENU,
            component: trialsMenu,
            children: [
                {
                    path: SC.Path.TRAIN_DATA_MENU,
                    component: trainDataMenu,
                    children: [
                        { path: SC.Path.TRAIN_DATA_UPLOAD, component: trainUpload },
                        { path: SC.Path.TRAIN_DATA_STATISTICS, component: trainStatistics },
                        { path: SC.Path.TRAIN_DATA_GETTING_KC_LIST, component: trainGettingKcList },
                    ],
                },
                {
                    path: SC.Path.TRAIN_KC_MENU,
                    component: trainKCMenu,
                    children: [
                        { path: SC.Path.TRAIN_KC_LIST, component: trainKCList },
                        { path: SC.Path.TRAIN_KC_TRAINING, component: trainKCTraining },
                    ],
                },
                {
                    path: SC.Path.TRAIN_RESULT_MENU,
                    component: trainResultMenu,
                    children: [
                        {
                            path: SC.Path.TRAIN_RESULT_ALL,
                            component: trainResultAll,
                            children: [
                                {
                                    path: SC.Path.TRAIN_RESULT_ALL_KC,
                                    component: trainResultKC,
                                },
                                {
                                    path: SC.Path.TRAIN_RESULT_ALL_PARAMS,
                                    component: trainResultParams,
                                },
                            ],
                        },
                        { path: SC.Path.TRAIN_RESULT_DATA, component: trainResultData },
                    ],
                },
                {
                    path: SC.Path.PREDICT_DATA_MENU,
                    component: predictDataMenu,
                    children: [
                        { path: SC.Path.PREDICT_DATA_UPLOAD, component: predictUpload },
                        { path: SC.Path.PREDICT_DATA_STATISTICS, component: predictStatistics },
                        { path: SC.Path.PREDICT_DATA_PREDICTING, component: predicting },
                    ],
                },
                {
                    path: SC.Path.PREDICT_RESULT_MENU,
                    component: predictResultMenu,
                    children: [{ path: SC.Path.PREDICT_RESULT_DATA, component: predictResultData }],
                },
            ],
        },
    ],
});

export default router;
